<script setup lang="ts">
import View from '~/pages-components/blog/catgory-list.vue'
</script>

<template>
  <div>
    <View />
  </div>
</template>
